import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Stakeholder } from "@/types";

export function useGetJobStakeholders() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["job-stakeholders", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/stakeholders`;
      const res = await guacHttpClient.get<
        Stakeholder[],
        HttpResponse<Stakeholder[]>
      >(path);
      return res.data;
    },
  });
}
